import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins/eosToast'
import i18n from './i18n'
import theme from './theme.scss'
import store from './store'
import ApiService from './api/apiservice'
import './service-worker'
import './components/components'
import './mixins/mixins'
import './mixins/snackbarMixin'
import './prototype'


//map
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

//
import VueMobileDetection from "vue-mobile-detection";
Vue.use(VueMobileDetection);

Vue.config.productionTip = false
ApiService.init();

const Instance = new Vue({
  router,
  vuetify,
  i18n,
  store,
  theme,
  beforeCreate() {
		//this.$store.commit('initialiseStore');
	},
  render: h => h(App)
}).$mount('#app')

export const { $store } = Instance;